<template class="has-text-centered">
    <i v-if="params.icon" class="material-icons">{{ params.icon }}</i>
</template>
<script>
export default {
    data(){
        return {
            params: this.$parent.params
        }
    },
    beforeMount(){
        console.log(this.$parent);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/empresas/components/CellHeaderIcon.vue